<template>
  <v-container fluid>
    <v-alert
      v-model="hasError"
      type="error"
      dense
    >
      <v-row>
        <v-col class="grow">
          Whoops, something went wrong
        </v-col>
      </v-row>
    </v-alert>
  </v-container>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';

export default {
  name: 'ErrorBar',
  computed: {
    ...mapGetters({
      hasError: 'apiClient/showError',
    }),
  },
  methods: {
    ...mapMutations('apiClient', ['dismissError']),
  },
};
</script>
